import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

interface UseGenerateEmailPreviewParams {
  eventEmailTemplateUuid: string;
  recipientType: string;
  recipientUuid: string;
}

export const generateEmailPreview = async (params: UseGenerateEmailPreviewParams) => {
  const response = await CustomAxios.get(`event_email_templates/${params.eventEmailTemplateUuid}/generate_preview`, {
    params: {
      recipient_type: params.recipientType,
      recipient_uuid: params.recipientUuid,
    },
  });
  const { data } = response;
  return data;
};

export function useGenerateEmailPreview(params: UseGenerateEmailPreviewParams) {
  const query = useQuery({
    queryKey: [queryKeys.generateEmailPreview, params.eventEmailTemplateUuid],
    queryFn: () => generateEmailPreview(params),
    enabled: !!params.eventEmailTemplateUuid && !!params.recipientUuid,
  });
  return query;
}
